import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { cn } from '@/lib/utils'

export type FilterInlineDateCalendarProps = {
  date?: Date
  onSelect?: (date: Date | undefined) => void
  showClearButton?: boolean
  /** Shown above the calendar when two pickers share one popover (e.g. custom date range). */
  label?: string
  /** Focus the calendar when the popover opens — use on one picker per popover only. */
  initialFocus?: boolean
  className?: string
}

/**
 * Inline calendar for filter popovers — no nested Popover trigger.
 * Use `DatePicker` in forms; use this inside `renderPopover` / `FilterDropdownBody`.
 */
export function FilterInlineDateCalendar({
  date,
  onSelect,
  showClearButton = false,
  label,
  initialFocus = false,
  className,
}: FilterInlineDateCalendarProps) {
  return (
    <div className={cn('flex flex-col', className)}>
      {label ? (
        <p className="px-3 pt-2 text-xs font-medium text-muted-foreground">{label}</p>
      ) : null}
      <Calendar
        mode="single"
        selected={date}
        onSelect={onSelect}
        initialFocus={initialFocus}
        className="p-3"
      />
      {showClearButton && date ? (
        <div className="border-t border-border/60 p-2">
          <Button
            type="button"
            variant="ghostMuted"
            size="sm"
            fullWidth
            onClick={() => onSelect?.(undefined)}
          >
            Clear date
          </Button>
        </div>
      ) : null}
    </div>
  )
}
